import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#020617] text-[#F8FAFC] pt-16 pb-8" data-id="element-19">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-12 items-start" data-id="element-21">
          {/* Brand */}
          <div data-id="element-22">
            <Link to="/" className="inline-flex items-center gap-2 font-heading text-2xl font-bold text-[#F8FAFC] mb-4 no-underline" data-id="element-23">
              <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip Logo" className="w-10 h-10 object-contain" data-id="element-24" />
              CorkShip
            </Link>
            <p className="text-[#64748B] text-[15px] leading-relaxed max-w-[320px]" data-id="element-25">
              Premium wine fulfilment for Australian wineries. Ship wine with confidence.
            </p>
          </div>

          {/* Legal links only */}
          <div className="flex items-start md:justify-end" data-id="element-26">
            <nav className="flex flex-wrap gap-6" data-id="element-27">
              <Link to="/docs/commerce7" className="text-[15px] text-[#64748B] hover:text-[#F8FAFC] transition-colors no-underline" data-id="element-28">Docs</Link>
              <Link to="/terms" className="text-[15px] text-[#64748B] hover:text-[#F8FAFC] transition-colors no-underline" data-id="element-29">Terms</Link>
              <Link to="/privacy" className="text-[15px] text-[#64748B] hover:text-[#F8FAFC] transition-colors no-underline" data-id="element-30">Privacy</Link>
            </nav>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10" data-id="element-31">
          <p className="text-sm text-[#64748B] text-center md:text-left" data-id="element-32">
            © 2026 CorkShip. All rights reserved. Made with care in Australia.
          </p>
        </div>
      </div>
    </footer>;
}